import React, { Component } from 'react';
import { connect } from 'react-redux';
import bindActionGroups from 'redux-bind-action-groups';
import {
  NitroButton,
  NitroButtonGroup,
  NitroHeading,
  NitroParagraph,
  NitroLoading,
  NitroCheckbox,
  NitroTextField,
  NitroPanel,
} from 'nitro-components';
import styled from 'styled-components';
import { media } from 'style-utils';

import * as profileActions from './actions';
import { getProfile } from './selector';
import { notify } from '../../components/libs/notification';
import formPasswordCheck from '../../utils/forms/form-password-check';
import {
  ERROR_PASSWORD,
  ERROR_CURRENT_PASSWORD_REQUIRED,
  ERROR_CURRENT_PASSWORD_INVALID,
  SUCCESS_PASSWORD_UPDATED,
  SUCCESS_PASSWORD_UPDATED_TITLE,
  INFO_PASSWORD_STRENGTH,
} from '../../utils/forms/const-messages';

const ShowPassword = styled.div`
  margin-top: 20px;
`;

const ActionSection = styled.div`
  margin-top: 10px;
`;

export const Container = styled.div`
  display: flex;
  ${media.desktop`
  flex-direction: row
  `} ${media.mobile`
  flex-direction: column
  `}
  justify-content: space-between;
`;

export const PasswordSection = styled.div`
  ${media.desktop`
  width: 40%
  `} ${media.mobile`
  width: 100%
  `}
  display: flex;
  flex-direction: column;
`;

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // form values stored here onChange of inputs
      formData: {
        oldPassword: '',
        newPassword: '',
      },

      // default validation
      formValid: {
        oldPassword: true,
        newPassword: true,
      },

      // default state of inputs (false=password, true=input)
      // shows/hides password value
      showPassword: {
        oldPassword: false,
        newPassword: false,
      },

      // on form submit, set to true to show loading on button
      fetchingData: false,
      changePasswordResponse: false,
    };
    this.formData = this.formData.bind(this);
    this.showPassword = this.showPassword.bind(this);
    this.changePasswordResponse = this.changePasswordResponse.bind(this);
  }

  /*
        comporentWillRecieveProps
        before render: if change password api call successfull, empty formData state
      */

  componentWillReceiveProps(nextProps) {
    const response = nextProps.profile.response;

    this.changePasswordResponse(response);
  }

  changePasswordResponse(response) {
    const { changePasswordClearResponse } = this.props.actions.profileActions;

    if (!this.state.changePasswordResponse && response.success) {
      this.showNotification();

      this.setState({ fetchingData: false, changePasswordResponse: true });

      this.formDataReset();
      changePasswordClearResponse();
    } else {
      this.setState({ changePasswordResponse: false });
    }

    if (response.error) {
      this.setState({ fetchingData: false, changePasswordResponse: false });
    }
  }

  /*
        formDataReset
        empty formData values
      */

  formDataReset = () => {
    // empty form field data
    this.setState({
      formData: {
        oldPassword: '',
        newPassword: '',
      },
      formValid: {
        oldPassword: true,
        newPassword: true,
      },
    });
  };

  /*
        formDataCheckPassword
        checks password strength - method imported from utils
      */

  formDataCheckPassword = () => {
    const isValid = formPasswordCheck(this.state.formData.newPassword);

    // console.log(isValid);

    const formValid = this.state.formValid;
    formValid.newPassword = isValid.isValid;

    this.setState({ formValid });

    return isValid;
  };

  /*
        formDataCheck
        checks the length of each input value (there is only one right now)
      */

  formDataCheck = () => {
    const isValid = this.state.formData.oldPassword.length > 0;

    const formValid = this.state.formValid;
    formValid.oldPassword = isValid;

    this.setState({ formValid });

    return isValid;
  };

  /*
        formData
        onChange event on input saves form data in local state
      */

  formData(event) {
    const { name, value } = event.target;

    const formData = this.state.formData;
    formData[name] = value;

    this.setState({
      formData,
    });

    // perform data validation onChange - old password
    if (!this.state.formValid.oldPassword) {
      this.formDataCheck(value);
    }

    // perform data validation onChange - new password
    if (!this.state.formValid.newPassword) {
      this.formDataCheckPassword(value);
    }
  }

  /*
        onBlur
        only perform validation check when the user has started to enter something
        else no error is shown
      */

  formDataCheckOnBlur = event => {
    const { name, value } = event.target;

    if (value.length > 0 && name === 'newPassword') {
      this.formDataCheckPassword();
    }
    if (value.length > 0 && name === 'oldPassword') {
      this.formDataCheck();
    }
  };

  /*
        submitChangePassword
        invoked by: form submit to api
      */

  submitChangePassword = () => {
    const { changePassword } = this.props.actions.profileActions;

    // check is form is valid, submit to api
    if (this.formDataCheck() && this.formDataCheckPassword()) {
      this.setState({ fetchingData: true });

      // send oldPassword & newPassword to api
      changePassword(
        this.state.formData.oldPassword,
        this.state.formData.newPassword
      );
    }
  };

  /*
        showPassword
        invoked by: checkbox onCheck()
        name: inputName of text field to toggle input value
        true: hide input value
        false: show input value
      */

  showPassword = inputName => {
    // get showPassword
    const showPassword = this.state.showPassword;

    // toggle showPassword
    showPassword[inputName] = !showPassword[inputName];

    // set showPassword
    this.setState({
      showPassword,
    });
  };

  /*
        showNotification
        show toastr style notification
      */

  showNotification = () => {
    this.props.actions.notify({
      title: SUCCESS_PASSWORD_UPDATED_TITLE,
      message: SUCCESS_PASSWORD_UPDATED,
    });
  };
  render() {
    let success, errorCurrentPassword, buttonCancel;

    // console.log('state:', this.state);
    // console.log('form valid:', this.state.formValid);
    // console.log('profile:', this.props.profile.response);

    // show loading until profile data is returned
    if (this.props.profile.loading) {
      return <NitroLoading screen />;
    }

    // set error message if empty
    if (!this.state.formValid.oldPassword) {
      errorCurrentPassword = ERROR_CURRENT_PASSWORD_REQUIRED;
    }

    // api response - set in the reducer
    const response = this.props.profile.response;

    if (response.success) {
      success = <p>Updated</p>;
    }

    // api error
    if (response.error) {
      // set error message if password is invalid (server response)
      if (response.error.errorMessage) {
        errorCurrentPassword = ERROR_CURRENT_PASSWORD_INVALID;
      }
    }

    if (
      this.state.formData.oldPassword.length > 0 ||
      this.state.formData.newPassword.length > 0
    ) {
      buttonCancel = (
        <NitroButton size="small" action={this.formDataReset} label="Cancel" />
      );
    }
    return (
      <section>
        <NitroPanel padding="48px 24px">
          <NitroHeading label="Change password" size="2" noMargin />
          {success}
          <Container>
            <PasswordSection>
              <NitroTextField
                id="old-password-input"
                name="oldPassword"
                floatingLabelText="Current password"
                hintText="Enter your current password"
                label="Current password"
                onChange={this.formData}
                onBlur={this.formDataCheckOnBlur}
                type="password"
                errorText={errorCurrentPassword}
                value={this.state.formData.oldPassword}
                fullWidth
              />

              <br />

              <NitroTextField
                id="new-password-input"
                name="newPassword"
                floatingLabelText="New password"
                hintText="Enter your new password"
                label="New password"
                onChange={this.formData}
                onBlur={this.formDataCheckOnBlur}
                type={this.state.showPassword.newPassword ? '' : 'password'}
                errorText={
                  this.state.formValid.newPassword ? '' : ERROR_PASSWORD
                }
                value={this.state.formData.newPassword}
                fullWidth
              />

              <ShowPassword>
                <NitroCheckbox
                  label="Show new password"
                  checked={this.state.showPassword.newPassword}
                  action={() => this.showPassword('newPassword')}
                />
              </ShowPassword>

              <ActionSection>
                <NitroParagraph>{INFO_PASSWORD_STRENGTH}</NitroParagraph>
              </ActionSection>

              <ActionSection>
                <NitroButtonGroup layout="horizontal">
                  <NitroButton
                    size="small"
                    action={this.submitChangePassword}
                    label="Change password"
                    variant="primary"
                    disabled={this.state.fetchingData}
                    loading={this.state.fetchingData}
                  />

                  {buttonCancel}
                </NitroButtonGroup>
              </ActionSection>
            </PasswordSection>
          </Container>
        </NitroPanel>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  profile: getProfile(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionGroups({ profileActions, notify }, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePassword);



// WEBPACK FOOTER //
// ./src/features/profile/ChangePassword.js